const APIS: any = {
  USER: {
    LOGIN: '/login',
    GET_ALL_USERS: '/user/getAllUser',
    ADD_UPDATE_USER: '/user/createOrUpdate',
    CHANGE_PASSWORD: '/user/changePassword',
  },
  ROLE: {
    GET_ALL_ROLES: '/user/getAllRoles',
    ADD_UPDATE_ROLE: '/user/add/role',
    USERS_ROLE_MAPPING: '/dashboard/postUserRoleMapping',
  },
  VISUALIZATION: {
    GET_ALL_VISUALIZATION: '/dashboard/getAllVisualizations',
    ADD_UPDATE_VISUALIZATION: '/dashboard/postChart',
    GET_VISUALIZATION: '/dashboard/getChartConfig?visualizationCode=',
    PREVIEW_CHART: '/dashboard/admin/previewChart',
  },
  DASHBOARD: {
    GET_ALL_DASHBOARD: '/dashboard/getAllDashboards',
    ADD_UPDATE_DASHBOARD: '/dashboard/postDashboard',
    GET_DASHBOARD: '/dashboard/getDashboard?profileName=',
    GET_DASHBOARDS_FOR_ROLE:'/dashboard/getDashboardsForRole?roleId=',
  },
  ACTIONS: {
    GET_ALL_ACTIONS: '/dashboard/getAllActions',
    GET_ACTIONS_FOR_ROLE: '/dashboard/getActionsForRole?roleId=',
  },
  AUTH: {
    FORGOT_PASSWORD: '/auth/forgot-password',
    VALIDATE_RESET_TOKEN: '/auth/validate-reset-token',
    RESET_PASSWORD: '/auth/reset-password',
  },
};

export { APIS };
